var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inheritAll"},[_c('iframe',{staticClass:"assetGraph",staticStyle:{"height":"500px","margin-top":"5px"},attrs:{"src":_vm.tile.iframeURL,"width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }